import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';
import poliFoundationRequest from '../../utils/poliFoundationRequest';
import WabaService from '../tools/template-waba/template-waba';
import axios from 'axios';
import poliConfig from 'src/utils/poliConfig';
import { laravelAxios } from 'src/config/axios/laravelAxios';

export const TriggerSuggestionService = {
  /**
   * Busca contatos sugeridos para disparo
   * @param {Object} params - Parâmetros da busca
   * @param {number} params.daysSinceLastMessage - Dias desde a última mensagem (7, 15, 30)
   * @param {number} params.considerAnyMessage - Considerar qualquer mensagem (0 ou 1)
   * @param {number} params.monthsWithoutPaidSale - Meses sem venda paga (1, 2, 3)
   * @param {number} params.neverSold - Nunca vendeu (0 ou 1)
   * @param {number} params.includeNullMessageDir - Incluir direção de mensagem nula (0 ou 1)
   * @param {number} params.page - Página atual
   * @returns {Promise<Object>} Response com dados dos contatos e metadados
   */
  getSuggestedContacts: async (params) => {
    try {
      const newParams = {
        ...params,
        include: 'attributes,metadata',
        days_since_last_message: params.daysSinceLastMessage || 7,
        months_without_paid_sale: params.monthsWithoutPaidSale || 1,
        limit: 50,
        per_page: 15,
        page: params.page || 1,
      };

      const response = await poliFoundationRequest.get(
        '/settings/suggestion-trigger/contacts',
        {
          params: newParams,
        }
      );

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar contatos sugeridos:', error);
      throw error;
    }
  },

  /**
   * Busca templates disponíveis por canal
   * @param {string} channelId - ID do canal selecionado
   * @param {string} customerId - ID do cliente
   * @returns {Promise<Array>} Lista de templates
   */
  getTemplates: async (channelId, customerId) => {
    try {
      if (!channelId || !customerId) {
        return [];
      }

      // Busca templates do canal específico usando o serviço WABA
      const response = await WabaService.getTemplatesWaba({
        customer_id: customerId,
        channel_id: channelId,
        status: 1, // apenas templates ativos
      });

      if (response && response.data) {
        return response.data;
      }

      return [];
    } catch (error) {
      console.error('Erro ao buscar templates:', error);
      return [];
    }
  },

  /**
   * Busca etiquetas disponíveis
   * @returns {Promise<Array>} Lista de etiquetas
   */
  getTags: async () => {
    try {
      // TODO: Implementar quando a API estiver disponível
      const response = await poliFoundationRequest.get('tags');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar etiquetas:', error);
      throw error;
    }
  },

  /**
   * Envia disparo para contatos selecionados
   * @param {Object} params - Parâmetros do disparo
   * @param {number} params.customer_id - ID do cliente
   * @param {string} params.entry_type - Tipo de entrada (WABA, WHATSAPP, etc.)
   * @param {number} params.entry_channel_id - ID do canal
   * @param {number} params.entry_user_id - ID do usuário
   * @param {string} params.entry_msg - Mensagem a ser enviada
   * @param {string} params.entry_email - Email do usuário
   * @param {boolean} params.entry_create_tag - Criar etiqueta
   * @param {boolean} params.entry_deduplicate_contact - Deduplicar contatos
   * @param {boolean} params.entry_international_phone - Telefone internacional
   * @param {Array} params.contacts - Lista de contatos com contact_id
   * @param {number|null} params.quick_message_id - ID da mensagem rápida (opcional)
   * @param {number|null} params.entry_custom_tag_id - ID da etiqueta personalizada (opcional)
   * @returns {Promise<Object>} Response da API
   */
  sendTrigger: async (params) => {
    try {
      const payload = {
        customer_id: params.customer_id,
        entry_type: params.entry_type,
        entry_channel_id: params.entry_channel_id,
        entry_user_id: params.entry_user_id,
        entry_msg: params.entry_msg,
        entry_email: params.entry_email,
        entry_create_tag: params.entry_create_tag ?? true,
        entry_deduplicate_contact: params.entry_deduplicate_contact ?? true,
        entry_international_phone: params.entry_international_phone ?? false,
        contacts: params.contacts.map((contact) => ({
          contact_id: Number(
            contact.contact_data.metadata.deprecated_contact_id
          ),
        })),
        quick_message_id: params.quick_message_id,
        entry_custom_tag_id: params.entry_custom_tag_id,
      };

      const response = await laravelAxios.post(
        `/api/trigger/complete`,
        payload
      );

      return response.data;
    } catch (error) {
      console.error('Erro ao enviar disparo:', error);
      throw error;
    }
  },
};
